// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // fileBaseUrl: 'http://localhost/eb-dashboard/public/files',
  // apiBaseUrl: 'http://localhost/eb-dashboard/public/api',
  fileBaseUrl: 'https://eb-develop-api.veeyaainnovatives.com/files',
  apiBaseUrl: 'https://eb-develop-api.veeyaainnovatives.com/api',
  // Note: appName is now configured in src/app/app-config.ts for white labeling
  // appName: 'EB Dashboard', // Deprecated - use AppConfigService instead
  version: '1.0.0',
  
  // API Configuration
  apiTimeout: 30000,
  apiRetryAttempts: 3,
  
  // Feature Flags
  enableDebugMode: true,
  enableAnalytics: false,
  enableErrorReporting: false,
  
  // Security
  enableHttps: false,
  enableCors: true,
  
  // Cache Configuration
  cacheTimeout: 60000, // 1 minute for development
  
  // File Upload
  maxFileSize: 10485760, // 10MB
  allowedFileTypes: ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],
  
  // Pagination
  defaultPageSize: 15,
  maxPageSize: 100,
  
  // Date/Time Configuration
  dateFormat: 'yyyy-MM-dd',
  timeFormat: 'HH:mm:ss',
  dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  
  // Localization
  defaultLanguage: 'en',
  supportedLanguages: ['en'],
  
  // Theme Configuration
  defaultTheme: 'light',
  availableThemes: ['light', 'dark'],
  
  // Notification Configuration
  notificationTimeout: 5000,
  maxNotifications: 5,
  
  // Dashboard Configuration
  dashboardRefreshInterval: 10000, // 10 seconds for development
  chartAnimationDuration: 1000,
  
  // Assignment Management
  enableAssignmentManagement: true,
  
  // Stock Management
  enableStockManagement: true,
  
  // Delivery Management
  enableDeliveryManagement: true,
  
  // Profile Management
  enableProfileManagement: true,
  
  // Token Configuration
  tokenRefreshThreshold: 30000, // 30 seconds before expiry
  tokenStorageKey: 'eb_dashboard_token',
  refreshTokenStorageKey: 'eb_dashboard_refresh_token',
  tokenExpiryStorageKey: 'eb_dashboard_token_expiry',
  
  // Development specific settings
  enableConsoleLogs: true,
  enablePerformanceMonitoring: false,
  mockApiResponses: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
